import { groq } from 'next-sanity';
import { z } from 'zod';

export const SanityIframeEmbed = z.object({
  _type: z.literal('iframeEmbed'),
  _key: z.string().optional().nullable(),
  iframeScript: z.string().refine(
    (value) => {
      // Check if the string starts with an iframe tag (case-insensitive, allowing whitespace before)
      const trimmedValue = value.trim();
      const iframeRegex = /^<iframe[\s>]/i;
      return iframeRegex.test(trimmedValue);
    },
    {
      message: 'iframeScript must start with an iframe tag',
    },
  ),
});

export type SanityIframeEmbed = z.infer<typeof SanityIframeEmbed>;

export const iframeEmbed = groq`{
  _type,
  defined(_key) => {
    _key,
  },
  iframeScript,
}`;
